<template>
    <div class="preloader">
        <div class="preloader__background"></div>
        <div class="preloader__animation">
            <div class="preloader__icon">
                <PreloaderIcon></PreloaderIcon>
            </div>
            <div class="preloader__text">
                <transition
                    mode="out-in"
                    @enter="enter"
                    @leave="leave"
                    :css="false">
                    <p v-html="preloaderText()" ref="preload" :key="preloaderTextIdx"></p>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import PreloaderIcon from '@/assets/svg/preloader.svg';

    export default {
        name: 'Preloader',
        components: {
            PreloaderIcon
        },
        data() {
            return {
                preloaderInterval: null,
                preloaderTextIdx: 0,
                preloaderTextArray: [
                    'Creating your account...',
                    'Still creating your account...',
                    'We’re working on it.<br> Give us a minute.',
                    'Maybe go get some coffee?<br> Or water? Tea sounds good too'
                ],
                documentScrollPosition: null
            }
        },
        methods: {
            enter(el, done) {
                TweenMax.from(el, 2, {
                    autoAlpha: 0, onComplete: () => {
                        done();
                    }
                });
            },

            leave(el, done) {
                TweenMax.to(el, 2, {
                    autoAlpha: 0, onComplete: () => {
                        done();
                    }
                });
            },

            preloaderText() {
                return this.preloaderTextArray[this.preloaderTextIdx];
            }
        },
        created() {
            this.$once('hook:destroyed', () => {
                document.body.removeAttribute('style');
                window.scrollTo(0, Math.abs(this.documentScrollPosition));
            });
        },
        mounted() {
            this.documentScrollPosition = document.body.getBoundingClientRect().y;
            document.body.setAttribute('style', `position:fixed; top:${this.documentScrollPosition}px; overflow: hidden;`);

            this.preloaderInterval = setInterval(() => {
                if (this.preloaderTextIdx < 3) {
                    this.preloaderTextIdx = this.preloaderTextIdx + 1;
                } else {
                    this.preloaderTextIdx = 0;
                }
            }, 3000);
        }
    }
</script>



// WEBPACK FOOTER //
// Preloader.vue?1b46a52c